import { ActionType } from "../action-types";
import { ConversationActionState } from "../reducers/conversationActionsReducer";
import { AppThunk } from "./types";
import { OperatorDto } from "../../dto/postLogin";
import { http } from "../../utils/http";
import axios from "axios";
import { addNotifications } from "./notifications";
import { NOTIFICATION_TIMEOUT } from "../../constants";
import { getConversations } from "./conversations";

export const setConversationAction = (payload: ConversationActionState) => ({
  type: ActionType.SET_CONVERSATION_ACTION,
  payload,
});

export const executeConversationAction =
  (conversationId: string): AppThunk<Promise<void>> =>
  async (dispatch, getState) => {
    const { conversationAction } = getState();
    const { type, reason, operator, unlockReasonId } = conversationAction;

    if (!type) {
      // niente da fare
      return;
    }

    const trimmedReason = (reason ?? "").trim();

    try {
      switch (type) {
        case "transfer": {
          if (!operator) {
            throw new Error("Seleziona un operatore per il trasferimento.");
          }

          const payload = {
            toTeamId: operator.teamId,
            toOperatorId: operator.id,
            reason: trimmedReason,
          };

          await http.post(
            `/api/Conversations/${conversationId}/transfer`,
            payload
          );

          break;
        }

        case "assign": {
          if (!operator) {
            throw new Error("Seleziona un operatore per l'assegnazione.");
          }

          const payload = {
            toOperatorId: operator.id,
            note: trimmedReason,
          };

          await http.post(
            `/api/Conversations/${conversationId}/assign`,
            payload
          );
          break;
        }

        case "block": {
          const payload = {
            reasonId: 0,
            notes: trimmedReason,
          };

          await http.post(`/api/Conversations/${conversationId}/lock`, payload);
          break;
        }

        case "unblock": {
          if (!unlockReasonId) {
            throw new Error("Seleziona un motivo di sblocco.");
          }

          const payload = {
            reasonId: unlockReasonId,
            notes: trimmedReason,
          };

          await http.post(
            `/api/Conversations/${conversationId}/unlock`,
            payload
          );
          break;
        }

        default:
          return;
      }

      // notifica di successo
      dispatch(
        addNotifications([
          {
            id: Date.now(),
            variant: "success",
            message: "Operazione eseguita con successo.",
            dismissAfter: NOTIFICATION_TIMEOUT,
          },
        ])
      );

      // TODO elimina chiamata perche la GET deve essere
      /*try {
        await (dispatch as any)(getConversations());
      } catch (e) {
        console.error("Errore refresh conversations:", e);
      }*/
    } catch (error) {
      let message = "Errore durante l'operazione.";

      if (axios.isAxiosError(error)) {
        const status = error.response?.status ?? "NO_STATUS";
        const text =
          typeof error.response?.data === "string"
            ? error.response.data
            : JSON.stringify(error.response?.data ?? "");
        message = `Errore ${status}: ${text}`;
      }

      dispatch(
        addNotifications([
          {
            id: Date.now(),
            variant: "error",
            message,
            dismissAfter: NOTIFICATION_TIMEOUT,
          },
        ])
      );

      throw error;
    }
  };
